export const FETCH_ORDER = "FETCH_ORDER";
export const FETCH_ORDER_COMPLETED = "FETCH_ORDER_COMPLETED";
export const FETCH_ORDER_FAILED = "FETCH_ORDER_FAILED";
export const UPDATE_ROAD_SHEET = "UPDATE_ROAD_SHEET";
export const UPDATE_ROAD_SHEET_COMPLETED = "UPDATE_ROAD_SHEET_COMPLETED";
export const UPDATE_ROAD_SHEET_FAILED = "UPDATE_ROAD_SHEET_FAILED";

export const fetchOrder = (orderId, orderType) => ({
  type: FETCH_ORDER,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/orders/byordertype/${orderType}/${orderId}.json`,
    method: "GET"
  },
});

// Devis complet (toutes ses prestations) : le companion n'en lit que les annexes
// des feuilles de route. Pas de reducer, la réponse est lue dans le composant.
export const fetchGroupedOrderDocuments = (groupedOrderId) => ({
  type: "FETCH_GROUPED_ORDER_DOCUMENTS",
  meta: {
    async: true,
    blocking: false,
    path: `/api/pro/orders/grouped/${groupedOrderId}.json`,
    method: "GET"
  },
});

// Allergènes des plats (fiches recettes Koust) pour le menu à imprimer.
export const fetchMenuAllergens = (orderId) => ({
  type: "FETCH_MENU_ALLERGENS",
  meta: {
    async: true,
    blocking: false,
    path: `/api/pro/orders/${orderId}/menu-allergens.json`,
    method: "GET"
  },
});

export const updateRoadSheet = (orderId, data) => ({
  type: "UPDATE_ROAD_SHEET",
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/orders/${orderId}/update_road_sheet.json`,
    method: "PUT",
    body: data,
  },
});

export const UPLOAD_ANNEXES = "UPLOAD_ANNEXES";
export const UPLOAD_ANNEXES_COMPLETED = "UPLOAD_ANNEXES_COMPLETED";
export const UPLOAD_ANNEXES_FAILED = "UPLOAD_ANNEXES_FAILED";

export const uploadAnnexes = (orderId, files) => ({
  type: UPLOAD_ANNEXES,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/orders/${orderId}/annexes.json`,
    method: "POST",
    body: files,
    isFormData: true,
  },
});

export const DELETE_ANNEX = "DELETE_ANNEX";
export const DELETE_ANNEX_COMPLETED = "DELETE_ANNEX_COMPLETED";
export const DELETE_ANNEX_FAILED = "DELETE_ANNEX_FAILED";

export const deleteAnnex = (orderId, annexId) => ({
  type: DELETE_ANNEX,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/orders/${orderId}/annexes/${annexId}.json`,
    method: "DELETE",
  },
});